function handleFirstTab(e) {
    if (e.keyCode === 9) { // tab
        document.body.classList.add('user-is-tabbing');
    }
}
window.addEventListener('keydown', handleFirstTab);
document.addEventListener("click", function(){
  document.body.classList.remove('user-is-tabbing');
});

$(function() {
  	new WOW().init();
  
  	/* Reduced motion: Replace slideToggle(), slideDown(), slideUp() with toggle(), show(), hide() */
  	var oSlideToggle = jQuery.fn.slideToggle;
    jQuery.fn.slideToggle = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.toggle.apply(this, arguments); 
      }else{
      	return oSlideToggle.apply(this, arguments);
      }
    };
    var oSlideDown = jQuery.fn.slideDown;
    jQuery.fn.slideDown = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.show.apply(this, arguments); 
      }else{
      	return oSlideDown.apply(this, arguments);
      }
    };
    var oSlideUp = jQuery.fn.slideUp;
    jQuery.fn.slideUp = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.hide.apply(this, arguments); 
      }else{
      	return oSlideUp.apply(this, arguments);
      }
    };
  	/* End of Reduced Motion */
  
  	jQuery.fn.sortDomElements = (function() {
        return function(comparator) {
            return Array.prototype.sort.call(this, comparator).each(function(i) {
                  this.parentNode.appendChild(this);
            });
        };
    })();
  
  	if(!isMobile.any) {
      $('body').addClass('isNotMobile'); 
    }

  	$(document).on("click", ".quantity-box .minus", function(e) {
      	e.preventDefault();
      	var input = $(this).parent().find('input[type=number]');
    	try {
          if(input.attr('min')<input.val()) {
          	input.get(0).stepDown();
          	input.change();
          }
        } catch(e) {
          var value = (parseInt(input.val())-1);
          input.val((value>=0 ? value : 0));
          input.change();
        }
  	});
  	$(document).on("click", ".quantity-box .plus", function(e) {
      	e.preventDefault();
      	var input = $(this).parent().find('input[type=number]');
    	try {
          input.get(0).stepUp();
          input.change();
        } catch(e) {
          var value = (parseInt(input.val())+1);
          input.val(value);
          input.change();
        }
  	});

  	/********* QUICK VIEW *********/
  	$(document).on('click', '.quick-view-btn', function(){
      var url = $(this).data('url');
      $('#loading-overlay').show();

      $.ajax({
        url: url,
        cache: false
      }).success(function(data){
        $('#loading-overlay').hide();
        Simplistic.openModal(data, 'quick-view');
        $('.quick-view img').addClass('lazyload lazypreload');
      });

      return false;
    });

    $(document).on('click', '.product-item .more-colors', function(){
      var url = $(this).closest('.product-item').find('.product-item-url').attr('href');
      window.location.href = url;
    });

    $(document).on({
      mouseenter: function () {
        $(this).closest('.product-item').find('.image-wrapper').addClass('hover');
      },
      mouseleave: function () {
        $(this).closest('.product-item').find('.image-wrapper').removeClass('hover');
      }
    }, ".product-item .badge");
  
    /* HORIZONTAL SCROLL BAR / CAROUSEL */
    var horizontalScroll = function(){
      $('.horizontal-scroll-overflow').each(function(){
        if(!$(this).hasClass('horizontal-init')){
          var gallery = $(this);
          var galleryAvailScroll = 0;
          var handlerAvailScroll = 0;
          var handlerLeft = 0;

          gallery.children(':first').addClass('horizontal-scroll-gallery');
          $(`<div class="custom-scrollbar-track hide medium-down--show"><span class="custom-scrollbar-handle"></span></div>`).insertAfter(gallery);

          var scrollbar = gallery.parent().find('.custom-scrollbar-track');
          var handler   = gallery.parent().find('.custom-scrollbar-track .custom-scrollbar-handle');

          function setPos() {
            galleryAvailScroll = gallery[0].scrollWidth - gallery.outerWidth(true); // PX
            handlerAvailScroll = scrollbar.width() - handler.width(); // PX
            handlerLeft = gallery.scrollLeft() * handlerAvailScroll / galleryAvailScroll;
            handler.css({left: handlerLeft});
          }
			
          $(this).addClass('horizontal-init');
        
          setPos(); // Get the sizes
          $(window).on("resize", setPos); // Also on resize

          // Scroll
          gallery.on("scroll", function (e) {
            setPos();
          });
      	}
      });
    };

    horizontalScroll();
  
    $(document).on('keypress', '[tabindex=0]:focus', function(event){
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13'){
        $(this).click(); 
      }
    });

  	if($('#side-cart').length > 0) {
    	initSideCart();
  	}$('body').delegate('.add-to-cart-form', 'submit', function(){
            if(validateAddCart($(this))) {
              addToCart($(this));
            }
            return false;
        });if( $(this).scrollTop()>=80 ) {
      $('.header-drop').addClass('scroll');
    } else {
      $('.header-drop').removeClass('scroll');
    }
    $(window).scroll($.throttle(15, function(){
      if($(this).scrollTop()<=50) {
        $('.scrollup').removeClass('fadein');
      } else {
        $('.scrollup').addClass('fadein');
      }if( $(this).scrollTop()>=80 ) {
          $('.header-drop').addClass('scroll');
        } else {
          $('.header-drop').removeClass('scroll');
        }if( $(this).scrollTop()>=80 ) {
        $('body').addClass('scroll');
      } else {
        $('body').removeClass('scroll');
      }
    }));

    $('.header-drop .main-menu').html($('#header .main-menu').html());
    $('.header-drop a, .header-drop button, .header-drop input').attr({'tabindex':'-1','aria-hidden':'true'});
  	setupDropdownMenus();  
  
	var resizePage = function(){
      var minHeight = window.innerHeight - $('#header').outerHeight() - $('#footer').outerHeight();
      $('.content-wrapper').css('min-height', minHeight);
    };
    resizePage();
    $(window).resize($.throttle(200, function(){     
      resizePage();
    }));

    $(document).on('click', '.scrollTo', function(){
      $.scrollTo($(this).attr('href'), 1000, {offset: -100});
      return false;
    });
	
	showCountdowns();
  
    $(document).on('click', '[data-ga]', function(){
      if(typeof ga != "undefined"){
        var category = '40 Boxes';
        if($(this).data('ga-category')){
          category =  $(this).data('ga-category');
        }
        var action = 'Click';
        if($(this).data('ga-action')){
          action =  $(this).data('ga-action');
        }
        var label = $(this).text();
        if($(this).data('ga-label')){
          label =  $(this).data('ga-label');
        }
        ga('send', {hitType: 'event', eventCategory: category, eventAction: action, eventLabel: label, eventValue: 1});
      }
    });

    
      
        window.shippingThreshold = $('#side-cart .freeshipping').data('threshold');
      
    
});

function showCartProgression() {
  if(window.shippingThreshold){
    var threshold = window.shippingThreshold * 100;
    var cartTotal = $('#side-cart .freeshipping .progress').data('total');
    var progress = cartTotal * 100 / threshold;
    var away = (threshold - cartTotal) / 100;
    var progressElement = $('#side-cart .freeshipping .progress');
    var awayElement = $('#side-cart .freeshipping .away');
    if(progress > 100){
      progress = 100;        
    }
    awayElement.html('$' + away);
    setTimeout(function() {
      if(progress == 100){
        $('#side-cart .freeshipping .true').slideDown();
      }else{
        $('#side-cart .freeshipping .false').slideDown();
      }
      setTimeout(function() {
        progressElement.css('width', progress + '%');
      },500);
    },300);
  }
}

function showCountdowns() {
  	$.get('/cart?view=datetime&cache=false', function(currentTime){
      var currentSeconds = new Date().getSeconds().toString();
      var now = Simplistic.strToDate(currentTime+":"+currentSeconds).getTime(); 
      
      $('.floating-date').each(function(){
      	var ending = Simplistic.strToDate($(this).data('ending')).getTime();
        var distance = ending - now;
        // Time calculations for days, hours, minutes and seconds
        //var days = Math.round(distance / (1000 * 60 * 60 * 24));
        var daysMinus6h = Math.ceil((distance - (1000 * 60 * 60 * 6)) / (1000 * 60 * 60 * 24));
        var hours = Math.round((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + (daysMinus6h*24);
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        
        if(daysMinus6h <= 3 && (daysMinus6h>0 || hours>0 || minutes>0)) {
          if(daysMinus6h > 1) {
            var number = daysMinus6h;
            var unit = daysMinus6h>1 ? 'Days' : 'Day';
            var className = 'normal';
          } else {
            if(hours > 6) {
              var number = 'Ends';
              var unit = 'Tonight';
              var className = 'tonight';
            } else {
              return false;
              /*if(hours > 0) {
                var number = hours;
                var unit = hours>1 ? 'Hours' : 'Hour';
            	var className = 'normal';
              } else {
                var number = minutes;
                var unit = minutes>1 ? 'Min.' : 'Min.';
            	var className = 'normal';
              }*/
            }
          }
          var html = `
              <div class="bubble flex align-items-center justify-content-center">
                 <div class="count ${className}">
                    <span class="number">${number}</span>
                    <span class="unit">${unit}</span> <span class="left">Left</span>
                 </div>
              </div>
          `;
          $(this).html(html);
        }
      });
    });
}

function setupDropdownMenus(){
  var config = {
    over: function () {
      $(this).find('.submenu:first').slideDown(300);
      $(this).addClass('action');
    }, 
    timeout: 400, 
    out: function () {
      $(this).find('.submenu:first').slideUp(300);
      $(this).removeClass('action');
    }
  };
  $('.main-menu .has-dropdown').hoverIntent(config);

  $(document).on('keydown', '.main-menu .has-dropdown a:focus', function(e){
    if (e.which == 32) { //Spacebar
      e.preventDefault();
      $(this).next().slideToggle(300);
    }
    if (e.which == 40) { //Arrow Down
      e.preventDefault();
      $(this).next().slideDown(300);
    }
    if (e.which == 38) { //Arrow Up
      e.preventDefault();
      $(this).next().slideUp(300);
    }
  });
  $(document).on('keydown', '.main-menu .has-dropdown .has-dropdown a:focus', function(e){
    if (e.which == 39) { //Arrow Right
      e.preventDefault();
      $(this).next().slideDown(300);
    }
    if (e.which == 37) { //Arrow Left
      e.preventDefault();
      $(this).next().slideUp(300);
    }
  });
  
  $(document).on('keydown', '.main-menu .has-dropdown a:focus', function(e){
    if (e.which == 27) { //Exit
      e.preventDefault();
      $(this).closest('.submenu').slideUp(300);
    }
  });
}

function validateAddCart(form) {
  var ok = true;
  var errorMsg = '';
  form.find('.error').removeClass('error');
  form.find('.error-msg').remove();

  if(form.find('input[name^=id]').val()=='') {
        var allOptionsSelected;
      	if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                  	$(this).addClass('error');
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
          	allOptionsSelected = false;
        }
      	
      	if(allOptionsSelected) {
          	errorMsg = form.find('.validation-msg').text();
          	if(errorMsg) {
          		alert(errorMsg);
            } else {
            	alert("The selected variant is sold out.");
            }
        } else {
        	var labels = [];
            form.find('.options label:visible').each(function(key, obj){
              	$(this).parent().find('select, input').addClass('error');
                labels.push($.trim($(obj).text().replace(':', '')));
            });
            errorMsg =  'This field is required.';
          	$('<div class="error-msg" style="display: block;">'+errorMsg+'</div>').insertAfter($(this));
        }
      	ok = false;
    }
  
  	if(ok) {
  		form.find('.required:visible').each(function(){
            if($(this).val()=='') {
              $(this).addClass('error');
                
                errorMsg = 'This field is required.';
                $('<div class="error-msg" style="display: block;">'+errorMsg+'</div>').insertAfter($(this));
                ok = false;
            }
        });
  	}
  
  	if(ok){
      form.find('[minlength]:visible').each(function(){
        var minlength = $(this).attr('minlength');
        if($(this).val().length < minlength) {
          $(this).parent().find('select, input').addClass('error');
          errorMsg = ($.trim($(this).parent().find('label').text().replace(':', '')))+' must have at least '+minlength+' characters';
          $('<div class="error-msg" style="display: block;">'+errorMsg+'</div>').insertAfter($(this));
          ok = false;
        }
      });
    }
  
  	if(ok){
      form.find('[maxlength]:visible').each(function(){
        var maxlength = $(this).attr('maxlength');
        if($(this).val().length > maxlength) {
          $(this).parent().find('select, input').addClass('error');
          errorMsg = ($.trim($(this).parent().find('label').text().replace(':', '')))+' must have at most '+maxlength+' characters';
          $('<div class="error-msg" style="display: block;">'+errorMsg+'</div>').insertAfter($(this));
          ok = false;
        }
      });
    }
  
  	if(ok){
      form.find('[type="text"]:visible').each(function(key, obj){
        if(ok) {
          var name = $(this).attr('name');
          var label = $(obj).parent().find('label').text();
          if(form.find('[name="'+name+'"]:visible').length>1) {
            form.find('[name="'+name+'"]:visible').each(function(key2, obj2){
              if($(obj).val()!=$(obj2).val()) {
                $(this).parent().find('select, input').addClass('error');
                errorMsg = ($.trim(label.replace(':', '')))+' must match with its confirmation.';
                $('<div class="error-msg" style="display: block;">'+errorMsg+'</div>').insertAfter($(this));
                ok = false;
              }
            });
          }
        }
      });
    }
  
    if(!ok) {
      $('#notification-bar').removeClass('ok').html(errorMsg + '<svg version="1.1" x="0px" y="0px" width="20.5px" height="20.25px" viewBox="0 0 20.5 20.25" class="error-cross"><line fill="none" stroke="#FFFFFF" stroke-width="3" stroke-miterlimit="10" x1="1.234" y1="1.12" x2="19.277" y2="19.163"/><line fill="none" stroke="#FFFFFF" stroke-width="3" stroke-miterlimit="10" x1="19.277" y1="1.12" x2="1.234" y2="19.163"/></svg>').addClass('error active');

      var timeout = $('#notification-bar').data('timeout');
      if(timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(function(){
      	$('#notification-bar').removeClass('active');
      }, 4000);
      $('#notification-bar').data('timeout', timeout);
    }
  
  	return ok;
}

function initSideCart() {
	$('.header .cart-wrap').click(function(e){
      e.stopPropagation();
      showSideCart(true);
      return false;
    });

    $(document).click(function(event){
      if(!$(event.target).closest('#side-cart').length && $(event.target).attr('id')!="loading-overlay" && $('#side-cart').hasClass('open')) {
        hideSideCart();
      }
    });
}

function addToCart(form, callback){
	$('#loading-overlay').show();
  	if(modal) modal.close();
  
  	var productJs = form.closest('.initialized').data('productjs');
  	if(productJs) {
    	$(document).trigger("addToCart", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
    } else {
    	$(document).trigger("addToCart", [form]);
    }
  
	$.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: new FormData(form[0]),
      processData: false,
      contentType: false,
      dataType: 'json',
      error: addToCartFail,
      success: function(){
        if(productJs) {
          $(document).trigger("addToCartSuccess", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
        } else {
          $(document).trigger("addToCartSuccess", [form]);
        }
        if(callback) {
          callback();
        } else {
          addToCartSuccess();
        }
      },
      cache: false
	});
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
	updateCartDesc(true);
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  	var response = $.parseJSON(jqXHR.responseText);
  	$('#loading-overlay').hide();
  	Simplistic.openModal('<div class="error-itemincart">'+response.description+'</div>', 'message');
}

function updateCartDesc(openSideCart){
    if(location.pathname == '/cart'){
      location.reload();
    }
  	$.ajax({
		type: 'GET',
		url: '/cart?view=side-cart',
		cache: false,
      	success: function(data){
          $('#loading-overlay').hide();

          var animate = true;
          if($('#side-cart').width()>0 && $('#side-cart').hasClass('open')) {
            animate = false;
          }
          var sideCart = document.getElementById('side-cart');
          Simplistic.updateDynamicContent(sideCart, data);
          Simplistic.globalEval(data);
          if(modal) modal.close();
          if(openSideCart){
            showSideCart(animate);
          }
      	}
	});
}

function showSideCart(animate) {
  $('body, html').css({overflow: 'hidden'});
  $('#page').addClass('mode-overlay');
  if(animate) {
    setTimeout(function(){$('#side-cart').addClass('open')}, 100);
  } else {
    $('#side-cart').removeClass('ease-animation-slow');
  	$('#side-cart').addClass('open');
    setTimeout(function(){$('#side-cart').addClass('ease-animation-slow')}, 200);
  }

  showCartProgression();
  
  Simplistic.trapFocus({
    $container: $('#side-cart'), 
    namespace: 'side-cart'
  });
}

function hideSideCart() {
  $('#side-cart').removeClass('open');
  $('#page').removeClass('mode-overlay');
  $('body, html').css({overflow: ''});
  Simplistic.removeTrapFocus({
    $container: $('#side-cart'), 
    namespace: 'side-cart'
  });
}

window.SimplisticJS = function (){
  this.formatMoney = "$ \{\{amount\}\}";
  this.beforeTrapFocus = false;
  this.cart = {};
  
  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.trapFocus = function(options) {
    this.beforeTrapFocus = $(':focus');
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }
    if(this.beforeTrapFocus) {
    	this.beforeTrapFocus.focus();
      	this.beforeTrapFocus = false;
    }

    $(document).off(eventName);
  }
  
  this.handleize = function (str) {
    //source https://gist.github.com/dlindenkreuz/a439ec4b939f0561d6d9
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  };
  
  this.reducedMotion = function() {
  	return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  this.getQueryParam = function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  this.randomstring = function(L){
    var s= '';
    var randomchar=function(){
      var n= Math.floor(Math.random()*62);
      if(n<10) return n; //1-10
      if(n<36) return String.fromCharCode(n+55); //A-Z
      return String.fromCharCode(n+61); //a-z
    }
    while(s.length< L) s+= randomchar();
    return s;
  }

  this.validateEmail = function(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
  }

  this.openModal = function(content, css) {
    modal = new tingle.modal({
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: [css],
      beforeOpen: function() {
        $(".tingle-modal__close").appendTo(".tingle-modal-box__content");
        return true;
      },
      beforeClose: function() {
    	$(".tingle-modal__close").prependTo(".tingle-modal");
        return true;
      }
    });
    modal.setContent(content);
    modal.open();
  }

  this.onImagesLoaded = function(images, callback){
    var imagesLoaded = 0;
    var loadFunction = function() {
      imagesLoaded++;
      if(imagesLoaded==images.length) {
        callback();
      }
    };
    if(images.length>0) {
      images.each(function(){
        var img = new Image();
        img.onload = loadFunction;
        img.onerror = loadFunction;
        img.src = $(this).attr('src');
      });
    } else {
      callback();
    }
  };

  this.globalEval = function(textHtmlOrElement) {
    if (typeof(textHtmlOrElement)=="string") {
      var parser = new DOMParser();
      var doc = parser.parseFromString(textHtmlOrElement, 'text/html');
    } else {
      doc = textHtmlOrElement;
    }
    var scripts = doc.querySelectorAll('script');
    scripts.forEach(function(script) {
      if (script.src) {
        var d = document.createElement('script');
        for (var i= 0; i<script.attributes.length; i++) {
          d.setAttribute(script.attributes[i].name, script.attributes[i].value);
          document.head.appendChild(d).parentNode.removeChild(d);
        }
      } else {
        if(script.type!='application/json' && script.type!='text/template') {
          eval(script.innerHTML);
        }
      }
    })
  }

  this.updateDynamicContent = function(sourceContainer, newContentHtmlOrElement) {
    var newContentElement;
    if (typeof(newContentHtmlOrElement)=='string') {
      var parser = new DOMParser();
      newContentElement = parser.parseFromString(newContentHtmlOrElement, 'text/html');
    } else {
      newContentElement = newContentHtmlOrElement;
    }
    var dynamicAreas = sourceContainer.querySelectorAll('[data-dynamic-content]');
    dynamicAreas.forEach(function(srcArea) {
      var areaName = srcArea.dataset.dynamicContent;
      srcArea.outerHTML = newContentElement.querySelector('[data-dynamic-content="'+areaName+'"]').outerHTML;
    });

  }

  this.Media = new function() {
    var media = this;
    var mqS = window.matchMedia("(max-width: 600px)");
    var mqM = window.matchMedia("(max-width: 900px)");
    var mqO = window.matchMedia("(orientation: landscape)");
    var tId = 0;
    function updateMedia() {
      media.isLarge = !mqM.matches;
      media.isMediumUp = !mqS.matches;
      media.isMedium = mqM.matches && !mqS.matches;
      media.isMediumDown = mqM.matches;
      media.isSmall = mqS.matches;
      media.isLandscape = mqO.matches;
    }
    function handler() {
      clearTimeout(tId);
      tId = setTimeout(function() {
        updateMedia();
        $(window).trigger('mediaChange');
      }, 1);
    }
    updateMedia();
    mqS.addListener(handler);
    mqM.addListener(handler);
    mqO.addListener(handler);
    return this;
  }  
  
  this.strToDate = function(str){
  	var date = str.split(" ")[0].split('-');
    var time = str.split(" ")[1].split(':');
    
    var year = date[0];
    var month = parseInt(date[1])-1;
    var day = date[2];
    var hour = time[0];
    var min = time[1];
    var sec = time[2];
    
    return new Date(year, month, day, hour, min, sec);
  }

  this.refreshLimits = function() {
    $('[data-product-limit]').each(function(){
      var productId = $(this).data('product-id');
      var limit = $(this).data('product-limit');

      var itemCount = 0;
      Simplistic.cart.items.forEach(function(item){
        if(item.product_id==productId) {
          itemCount += item.quantity;
        }
      });
      var qtyAvailable = limit - itemCount;

      //PDP
      var selectQty = $(this).find('select[name="quantity"]');
      if(selectQty.length > 0) {
      	var selectedValue = selectQty.val();
        selectQty.find('option').remove();
        for(var i=1; i<=qtyAvailable; i++) {
          selectQty.append('<option value="'+i+'">' + i + '</option>');
        }
        if(!selectedValue || selectedValue>qtyAvailable) {
          selectedValue = 1;
        }
        selectQty.val(selectedValue);
      }

      if($(this).find('.limit-msg').length > 0) {
        if(qtyAvailable > 0) {
          $(this).find('.limit-msg').addClass('hide');
          $(this).find('.available-content').removeClass('hide');
        } else {
          $(this).find('.limit-msg').removeClass('hide');
          $(this).find('.available-content').addClass('hide');
        }
      }
    });
  }
};
window.Simplistic = new SimplisticJS();